import type { ModuleRoute } from '../types';
import { IntegrationsPage } from './IntegrationsPage';

/** Pages of this area (integrations: Slack and Teams connections, Microsoft 365 (Entra sync and SSO set-up)). Owned by Phase 4 task W27; only that task edits files in this folder (W32 wires it last). */
export const routes: ModuleRoute[] = [
  { path: '/manage/integrations', element: <IntegrationsPage />, permission: 'integrations.view' },
  // Microsoft returns here after consent (integrations s3); same page.
  { path: '/manage/integrations/microsoft', element: <IntegrationsPage />, permission: 'integrations.view' },
];
